import axios from "axios";
import config from "../config";

const userManagementService = axios.create({
  baseURL: config("service").user
});

export default userManagementService;
